import React from 'react'

export default function Screen() {
    return (
        <div className="screen">
            <div className="whiteScreen">
                <div className="white-one"></div>
                <div className="white-two"></div>
            </div>
            <div className="darkScreen">
                <div className="dark-one"></div>
                <div className="dark-two"></div>
            </div>
        </div>
    )
}
